import {z} from 'zod';

export const redriveRequestSchema = z.object({
  maxMessages: z.number().optional().default(10),
  includeAttributes: z.boolean().optional().default(true),
});
